import { HhsgSharedSideNavMenuItem } from "./side-nav-menu-item.model";

export class HhsgSharedSideNavHeader {
    iconClass: string;
    label: string;
    menuItems: HhsgSharedSideNavMenuItem[];
    name: string;
    selectedIconClass: string;
    routeUrl: string;
    queryParams?: any;
}